import React, { Fragment } from 'react'
import { useLocation } from 'react-router-dom';

const ArchitecturalReviewTab = ({ formik }: any) => {
    const location = useLocation();
    const isReadOnly = location.pathname.includes('/projects/view-project');
    return (
        <>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Architectural Design Schedule/Review</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsArchitecturalReviewDTO?.architecturalReview.slice(0, 14).map((architecturalReview: any, index: any) => (
                                <Fragment key={index}>
                                    {architecturalReview?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{architecturalReview?.name}</p>
                                            <div className="d-flex gap-5">
                                                <label className="checkboxs positionCheckBox ">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={architecturalReview.surveyResultRevised === '2'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultRevised`, architecturalReview.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={architecturalReview.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultOriginal`, architecturalReview.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : architecturalReview?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{architecturalReview?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultRevised`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultRevised`, e.target.value.toString())}
                                                        />
                                                        <label></label>

                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                        <label></label>

                                                    </div>
                                                </div>
                                            </div>
                                            : architecturalReview?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{architecturalReview?.name}</p>
                                                    <div className="d-flex gap-2 w-50">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultRevised`)}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${index}].surveyResultOriginal`)}
                                                            />
                                                            <label>  </label>

                                                        </div>

                                                    </div>
                                                </div>
                                                : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsArchitecturalReviewDTO?.architecturalReview.slice(14, 28).map((architecturalReview: any, index: any) => {
                                const actualIndex = index + 14; // Adjust the index to reflect the actual position in the array

                                return (
                                    <Fragment key={actualIndex}>
                                        {architecturalReview?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{architecturalReview?.name}</p>
                                                <div className="d-flex gap-5">
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={architecturalReview.surveyResultRevised === '2'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultRevised`, architecturalReview.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={architecturalReview.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultOriginal`, architecturalReview.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : architecturalReview?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{architecturalReview?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultRevised`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultRevised`, e.target.value.toString())}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                            />
                                                            <label></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                : architecturalReview?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{architecturalReview?.name}</p>
                                                        <div className="d-flex gap-2 w-50">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultRevised`)}
                                                                />
                                                                <label></label>

                                                            </div>
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsArchitecturalReviewDTO.architecturalReview[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 d-flex justify-content-end '>
                <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
            </div>
        </>
    )
}

export default ArchitecturalReviewTab